<h1 mat-dialog-title>Request a call</h1>
<div
  mat-dialog-content
  [sg-blockable]="callMeState.tracker.busy$ | async"
  [blockMessage]="callMeState.blockMessage"
  blockerStyle="progressBar"
  blockerStyleDirection="start"
  class="call-me-content">
  <div>
    @if (!callMeState.callResult && !callMeState.blockMessage) {
    <div class="phone-input-row">
      <div>Your phone number:</div>
      <sg-input
        class="phone-field"
        [formControl]="phoneFormControl"
        prefixIcon="phone"
        width="200px"
        [hideLabel]="true"
        data-test="callMePhoneInput"></sg-input>
      <sg-button
        class="action-btn"
        variant="ghost-primary"
        size="small"
        [icon]="callMeState.mode === 'edit' ? 'edit' : 'save'"
        [disabled]="callMeState.mode === 'save' && !callMeState.isPhoneValid(phoneFormControl.value)"
        (onClick)="callMeState.editNumber()"
        data-test="callMeActionBtn"
        tabindex="-1"></sg-button>
    </div>
    } @if (callMeState.callResult) {
    <div class="call-result">
      <h2 [class.sg-color-success]="!callMeState.isCallResultError" [class.sg-color-error]="callMeState.isCallResultError" data-test="callMeResult">
        {{ callMeState.callResult }}
      </h2>
    </div>
    }
  </div>
  <div class="dialog-actions sg-full-width">
    <sg-button variant="secondary" (onClick)="callMeState.close()" data-test="callMeCloseBtn" text="Close" tabindex="-1"></sg-button>
    <sg-button
      variant="primary"
      class="call-btn"
      [disabled]="callMeState.callResult || callMeState.mode === 'save' || !callMeState.isPhoneValid(session.user.phoneNumber)"
      (onClick)="callMeState.doCall()"
      data-test="callMeCallBtn"
      text="Call"
      tabindex="-1"></sg-button>
  </div>
</div>
